import React from 'react'
import "./AboutUs.css"
import { InnerPageHeader } from '../../components'
import { Container } from "react-bootstrap";


const AboutUs = ({ pageData,url }) => {

  const templates = pageData?.content?.templates || [];

  return (
    <div className="">
      <InnerPageHeader title={pageData?.page_title || "About Us"} />
      <Container className="" style={{ marginTop: "100px" }}>
        <div className="about-container">
          {templates.length > 0 ? (
            templates.map((template, index) => (
              <section key={index} className="my-4">
                {template.data?.title && <h2>{template.data.title}</h2>}
                {template.data?.description && (
                  <div
                    className="prose"
                    dangerouslySetInnerHTML={{
                      __html: template.data.description,
                    }}
                  />
                )}
              </section>
            ))
          ) : (
            <p>No content available</p>
          )}
        </div>
      </Container>
    </div>
  );
}

export default AboutUs